import { StretchPopup } from './stretchPopup';
import { ErrorToolTip } from '../general/newErrorToolTip';

export class PopupManager {
    public static init() {
        $(document).on('click', '.popup-manager-trigger', this.handleTrigger);
    }

    public static handleTrigger() {
        const action = $(this).data('action');

        if (action === 'openSingle') {
            const target = $(this).data('target');
            PopupManager.openSingle(target);
        }
    }

    public static closeAll() {
        $('.popup-window').removeAttr('data-visible');
        ErrorToolTip.getTooltipElement().hide();
        $('.error').removeClass('error');
    }

    public static openSingle(target: string) {
        PopupManager.closeAll();
        $(`.popup-window[data-popup-id="${target}"]`).attr('data-visible', 'true');
        StretchPopup.stretch();
    }
}
